/**
 * Index Controller
 */
/*
  globals moment
*/
(function(angular) {
    'use strict';

    var app = angular.module('asSecureCommerce');

    app.controller('PentestTasksIndexController', [
        '$scope',
        '$window',
        '$timeout',    
        'seApi',
        function($scope, $window, $timeout, seApi) {
            $scope.task_id = '';
            
            $scope.deleteTask = function(task_id) {                                                                                 
                $scope.task_id = task_id;
                
                showModalDialog('Please confirm that you are going to delete task '+ $scope.task_id +' (can not be undone)', function() {
                    $('#loader').parent().show();
                    $('#loader').show();
                    
                    seApi.delete("pentestTasks", JSON.stringify({task_id: $scope.task_id})).then(
                        function(data) {                            
                            $window.location.href = '/#!/se/pentestTasks';
                            $.alert('success', 'message' in data ? data.message : 'Task was successfully deleted', true);
                            $('#loader').parent().hide();
                            $('#loader').hide();
                            $window.setTimeout(function() {$window.location.reload();}, 1500);                          
                        },
                        function(data) {                            
                            $window.location.href = '/#!/se/pentestTasks';
                            let error = 'message' in data ? ': '+data.message : '';
                            $.alert('error', 'Error occured'+error, true);
                            $('#loader').parent().hide();
                            $('#loader').hide();
                        }
                    );
                });                 
            };
        },
    ]);
})(window.angular);
